/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetMostOrderedItems_2$Params {
  VenueId?: string;
  SelectedDate?: string;
}

export function getMostOrderedItems_2(http: HttpClient, rootUrl: string, params?: GetMostOrderedItems_2$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, getMostOrderedItems_2.PATH, 'get');
  if (params) {
    rb.query('VenueId', params.VenueId, {});
    rb.query('SelectedDate', params.SelectedDate, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

getMostOrderedItems_2.PATH = '/api/pos/User/getmostordereditems';
